import { createNamespace } from '@swagger-api/apidom-core';
import namespace from '@swagger-api/apidom-ns-api-design-systems';

const apiDesignSystemsNamespace = createNamespace(namespace);

export default apiDesignSystemsNamespace;
